<template>
  <div class="well well--library">
    <div class="share-link-panel">
      <h4 class="share-link-header text-left">Share with colleagues or caregivers</h4>
      <button
        v-show="!shared"
        @click="shareStrategy()"
        :disabled="sharing"
        class="btn btn-primary btn-block">
        <span v-if="!sharing"><i class="fa fa-link"/> Create a Shareable Link</span>
        <span v-if="sharing"><i class="fa fa-circle-o-notch fa-spin fa-fw"/> Loading...</span>
      </button>
      <div v-show="shared">
        <p class="share-link-warning"><i class="fa fa-eye"/> Anyone with the link can view<br><a
          class="make-private"
          v-if="editorVisibility"
          @click="unshareStrategy()"
          role="button"><small>Make private</small></a></p>
        <p class="input-group">
          <span class="input-group-addon"><i class="fa fa-link"/></span>
          <input
            @focus="$event.target.select()"
            type="text"
            class="form-control shared-link-display"
            readonly
            :value="shareLink">
        </p>
        <CopyButton
          btn-class="btn btn-default btn-block"
          :copy-text="shareLink"
          success-text="Link copied!"
          error-text="Error copying text! Use Ctrl + C instead."
          @copied="handleLinkCopied"
        >
          <i class="fa fa-link" aria-hidden="true"/> Copy Link
        </CopyButton>
      </div>
    </div>
    <LimitActionModal :show.sync="showBlocker" :action-permissions="actionPermissions" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONTENT_TYPES, ACTION_TYPES, actionPermissions } from '@/util/access_visibility'

import { shareStrategy, unshareStrategy } from '@/api/strategies'

import LimitActionModal from '@/components/LimitActionModal'
import CopyButton from '@/components/CopyButton'

export default {
  name: 'ShareStrategyPanel',
  components: {
    LimitActionModal,
    CopyButton
  },
  props: {
    uuid: {
      required: true,
      type: String
    },
    shareState: {
      required: true,
      type: Boolean
    },
    shareLinkState: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      sharing: false,
      shared: this.shareState,
      shareLink: this.shareLinkState,
      showBlocker: false
    }
  },
  computed: {
    ...mapGetters('visibility', ['editorVisibility']),
    ...mapGetters('user', ['authInfo']),
    actionPermissions() {
      return actionPermissions(ACTION_TYPES.SHARE, CONTENT_TYPES.SAVED_STRATEGY, {}, this.authInfo)
    }
  },
  methods: {
    shareStrategy() {
      this.sharing = true
      shareStrategy(this.uuid)
        .then(data => {
          this.sharing = false
          this.shared = true
          this.shareLink = data.share_link
          this.$sendEvent('Library Strategy Shared')
        })
        .catch(() => {
          this.sharing = false
        })
      this.$sendEvent('Clicked Create Share Link')
    },
    unshareStrategy() {
      unshareStrategy(this.uuid).then(() => {
        this.shared = false
      })
    },
    handleLinkCopied() {
      this.$sendEvent('Copied Share Link', {
        share_content_type: CONTENT_TYPES.SAVED_STRATEGY
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.share-link-warning {
  padding: 10px 0;
  background-color: @brand-primary;
  border: 1px solid @gray-lighter;
  border-radius: 4px;
  color: white;
}
.share-link-panel {
  text-align: center;
}
.shared-link-display {
  overflow: hidden;
  cursor: text;
}
.make-private {
  color: #d6f0f7;
}
</style>
